import styled from "styled-components";

export const ActionWrapper = styled.div`
  margin-bottom: 20px;
  scroll-margin-top: 140px;

  h3 {
    color: ${({ theme }) => theme.default.color.text.dark};
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-size: 32px;
    font-weight: 800;
    line-height: 40px;
    margin-bottom: 8px;
  }

  span {
    color: ${({ theme }) => theme.default.color.text.dark};
    font-family: ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    margin-bottom: 8px;
  }

  .button_wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
  }
`;
